const associatedDevices = {
  "pol/ols/mpk/tram/sig/zoneA4/Br/pme/4": [
    "pol/ols/mpk/tram/sig/zoneA4/Br/vet/5",
    "pol/ols/mpk/tram/sig/zoneA4/Br/vet/6",
    "pol/ols/mpk/tram/sig/zoneA4/Br/tc/14"
  ],
  "pol/ols/mpk/tram/sig/zoneA4/Br/pme/3": [
    "pol/ols/mpk/tram/sig/zoneA4/Br/vet/7",
    "pol/ols/mpk/tram/sig/zoneA4/Br/vet/8",
    "pol/ols/mpk/tram/sig/zoneA4/Br/tc/11"
  ],
  "pol/ols/mpk/tram/sig/zoneA4/Br/pme/2": [
    "pol/ols/mpk/tram/sig/zoneA4/Br/vet/1",
    "pol/ols/mpk/tram/sig/zoneA4/Br/vet/2",
    "pol/ols/mpk/tram/sig/zoneA4/Br/tc/6"
  ],
  "pol/ols/mpk/tram/sig/zoneA4/Br/pme/1": [
    "pol/ols/mpk/tram/sig/zoneA4/Br/vet/3",
    "pol/ols/mpk/tram/sig/zoneA4/Br/vet/4",
    "pol/ols/mpk/tram/sig/zoneA4/Br/tc/3"
  ],
  "pol/ols/mpk/tram/sig/zoneD/Br/pme/1": [
    "pol/ols/mpk/tram/sig/zoneD/Br/vet/3",
    "pol/ols/mpk/tram/sig/zoneD/Br/tc/3"
  ],
  "pol/ols/mpk/tram/sig/zoneA1/Br/pme/3": [
    "pol/ols/mpk/tram/sig/zoneA1/Br/vet/1",
    "pol/ols/mpk/tram/sig/zoneA1/Br/tc/13"
  ],
  "pol/ols/mpk/tram/sig/zoneA1/Br/pme/2": [
    "pol/ols/mpk/tram/sig/zoneA1/Br/vet/5",
    "pol/ols/mpk/tram/sig/zoneA1/Br/vet/6",
    "pol/ols/mpk/tram/sig/zoneA1/Br/tc/9"
  ],
  "pol/ols/mpk/tram/sig/zoneA1/Br/pme/1": [
    "pol/ols/mpk/tram/sig/zoneA1/Br/vet/5",
    "pol/ols/mpk/tram/sig/zoneA1/Br/vet/6",
    "pol/ols/mpk/tram/sig/zoneA1/Br/tc/5"
  ],
  "pol/ols/mpk/tram/sig/zoneA1/Br/pme/4": [
    "pol/ols/mpk/tram/sig/zoneA1/Br/vet/5",
    "pol/ols/mpk/tram/sig/zoneA1/Br/vet/6",
    "pol/ols/mpk/tram/sig/zoneA1/Br/tc/14"
  ],
  "pol/ols/mpk/tram/sig/zoneA1/Br/pme/5": [
    "pol/ols/mpk/tram/sig/zoneA1/Br/vet/1",
    "pol/ols/mpk/tram/sig/zoneA1/Br/vet/2",
    "pol/ols/mpk/tram/sig/zoneA1/Br/vet/3",
    "pol/ols/mpk/tram/sig/zoneA1/Br/vet/4",
    "pol/ols/mpk/tram/sig/zoneA1/Br/tc/15"
  ],
  "pol/ols/mpk/tram/sig/zoneA1/Br/pme/6": [
    "pol/ols/mpk/tram/sig/zoneA1/Br/vet/6",
    "pol/ols/mpk/tram/sig/zoneA1/Br/tc/17"
  ],
  "pol/ols/mpk/tram/sig/zoneC1/Br/pme/5": [
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/5",
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/6",
    "pol/ols/mpk/tram/sig/zoneC1/Br/tc/3"
  ],
  "pol/ols/mpk/tram/sig/zoneC1/Br/pme/6": [
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/1",
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/2",
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/9",
    "pol/ols/mpk/tram/sig/zoneC1/Br/tc/4"
  ],
  "pol/ols/mpk/tram/sig/zoneC1/Br/pme/1": [
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/5",
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/6",
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/7",
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/8",
    "pol/ols/mpk/tram/sig/zoneC1/Br/tc/12"
  ],
  "pol/ols/mpk/tram/sig/zoneC1/Br/pme/2": [
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/3",
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/4",
    "pol/ols/mpk/tram/sig/zoneC1/Br/tc/13"
  ],
  "pol/ols/mpk/tram/sig/zoneC1/Br/pme/3": [
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/3",
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/4",
    "pol/ols/mpk/tram/sig/zoneC1/Br/tc/15"
  ],
  "pol/ols/mpk/tram/sig/zoneC1/Br/pme/4": [
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/7",
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/8",
    "pol/ols/mpk/tram/sig/zoneC1/Br/tc/16"
  ],
  "pol/ols/mpk/tram/sig/zoneC1/Br/pme/7": [
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/6",
    "pol/ols/mpk/tram/sig/zoneC1/Br/tc/18"
  ],
  "pol/ols/mpk/tram/sig/zoneC1/Br/pme/8": [
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/3",
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/4",
    "pol/ols/mpk/tram/sig/zoneC1/Br/tc/21"
  ],
  "pol/ols/mpk/tram/sig/zoneC1/Br/pme/9": [
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/5",
    "pol/ols/mpk/tram/sig/zoneC1/Br/vet/6",
    "pol/ols/mpk/tram/sig/zoneC1/Br/tc/26"
  ],
  "pol/ols/mpk/tram/switch/001/Tsc/shv/pme/1": [
    "pol/ols/mpk/tram/switch/001/Tsc/shv/vet/1",
    "pol/ols/mpk/tram/switch/001/Tsc/shv/tc/2"
  ],
  "pol/ols/mpk/tram/switch/002/Tsc/shv/pme/1": [
    "pol/ols/mpk/tram/switch/002/Tsc/shv/vet/1",
    "pol/ols/mpk/tram/switch/002/Tsc/shv/tc/2"
  ],
  "pol/ols/mpk/tram/switch/003/Tsc/shv/pme/1": [
    "pol/ols/mpk/tram/switch/003/Tsc/shv/vet/1",
    "pol/ols/mpk/tram/switch/003/Tsc/shv/tc/2"
  ],
  "pol/ols/mpk/tram/switch/004/Tsc/shv/pme/1": [
    "pol/ols/mpk/tram/switch/004/Tsc/shv/vet/1",
    "pol/ols/mpk/tram/switch/004/Tsc/shv/tc/2"
  ],
  "pol/ols/mpk/tram/switch/005/Tsc/shv/pme/1": [
    "pol/ols/mpk/tram/switch/005/Tsc/shv/vet/1",
    "pol/ols/mpk/tram/switch/005/Tsc/shv/tc/2"
  ],
  "pol/ols/mpk/tram/switch/006/Tsc/shv/pme/1": [
    "pol/ols/mpk/tram/switch/006/Tsc/shv/vet/1",
    "pol/ols/mpk/tram/switch/006/Tsc/shv/tc/2"
  ],
  "pol/ols/mpk/tram/switch/007/Tsc/shv/pme/1": [
    "pol/ols/mpk/tram/switch/007/Tsc/shv/vet/1",
    "pol/ols/mpk/tram/switch/007/Tsc/shv/tc/2"
  ]
}

const getAssetById = (assetId, assets) => {
  return assets.filter(asset => assetId === asset.id).pop() || {}
}

const getAssetByPath = (path, assets) => {
  return assets.filter(({ shvPath, shvSuffixPath }) => path === `${shvPath}/${shvSuffixPath}`).pop()
}

const getAssociatedAssetIds = (assetId, assets) => {
  const { shvPath, shvSuffixPath } = getAssetById(assetId, assets)
  const associatedPaths = associatedDevices[`${shvPath}/${shvSuffixPath}`]
  if (associatedPaths) {
    return associatedPaths
      .map(path => {
        const asset = getAssetByPath(path, assets)
        return asset ? asset.id : undefined
      })
      .filter(id => !!id)
  }
  return []
}

export {
  associatedDevices,
  getAssociatedAssetIds
}
